module.exports = __webpack_public_path__ + "img/1015_sp.c8b155da.gif";